@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Error Log"
                  cancelHelpContentId="app.cancel"
                  cancelClass="btn-primary"
                  [hideSave]="true"
                  (cancel)="cancel()">
    <div class="error-log-contents">
        @if (errorLog) {
            <div class="d-flex flex-column w-100 h-100">
                <div class="d-flex flex-column">
                    <label>JSON:</label>
                    <div class="d-flex flex-column">
                        {{ errorLog.json }}
                    </div>
                </div>
                <div class="d-flex flex-column ws-flex-auto">
                    <label>Exception:</label>
                    <div class="d-flex flex-column" style="white-space: pre">
                        {{ errorLog.exception }}
                    </div>
                </div>
            </div>
        }
        @if (!errorLog) {
            <div class="d-flex flex-column w-100 h-100">
                <span>No data.</span>
            </div>
        }
    </div>
</ws-modal-wrapper>
